module.exports = __webpack_public_path__ + "img/img-learning_lounge.ec270968.svg";